import type React from 'react';

import PlaceholderImg from '@assets/verktoyplaceholder400x400.png';
import styles from '@components/entry-page/styles/verktoyLogo.module.scss';
import { GrafiskElementType, type MittVerktoyItem, type Verktoy } from '@src/types/minhelseentities';

type Props = {
  verktoy?: Verktoy;
  logoId?: number | null;
  mittVerktoy?: MittVerktoyItem;
  width?: number | string;
  height?: number | string;
  alt?: string;
  className?: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
};

const getLogoSrcFromVerktoy = (verktoy: Verktoy): string | null => {
  const logo = verktoy.GrafiskeElementer?.find(x => x.TypeId === GrafiskElementType.Ikon);
  return logo && logo.Id ? `/proxy/verktoynetcore/api/v1/GrafiskElement/AnonymBruk?id=${logo.Id}` : null;
};

const getLogoSrcFromId = (logoId: number): string => `/proxy/verktoynetcore/api/v1/GrafiskElement/AnonymBruk?id=${logoId}`;

export const VerktoyLogo: React.FC<Props> = ({ verktoy, logoId, height = 56, width = 56, alt = 'Verktøy logo', className, imgProps }) => {
  let logoSrc: string | null = null;
  if (logoId !== null && logoId !== undefined) {
    logoSrc = getLogoSrcFromId(logoId);
  } else if (verktoy) {
    logoSrc = getLogoSrcFromVerktoy(verktoy);
  }

  const imageSrc = logoSrc || PlaceholderImg;
  const imageAlt = logoSrc ? alt : 'defaultverktoyicon';
  const combinedClassName = [styles.logo, className].filter(Boolean).join(' ');

  return <img src={imageSrc} height={height} width={width} className={combinedClassName} alt={imageAlt} {...imgProps} />;
};
